function StudentLocationsCreateController() {
  const vm = this;
}
StudentLocationsCreateController.$inject = [];
export default StudentLocationsCreateController;
